exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".eps-card__submit[data-v-53056bd2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", "", {"version":3,"sources":["/home/webuser/yokohama/releases/50/spa/src/pages/prizes/epsCard/EpsCard.scss"],"names":[],"mappings":"AACE,mCACE,oBAAA,oBAAA,aACA,yBAAA,sBAAA,kBAAA,CAAA","file":"EpsCard.scss?vue&type=style&index=0&id=53056bd2&lang=scss&scoped=true&","sourcesContent":[".eps-card {\n  &__submit {\n    display: flex;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);

// exports
